//JavaScript Document
import React, { Component } from "react";

export default class notifyDetail extends Component {
  render() {
    return (
      <iframe
        src={decodeURIComponent(this.props.match.params.url)}
        className="commonFrame"
        allowfullscreen="true"
      ></iframe>
    );
  }
}
